<section class="content head">
  <div class="content-wrapper">
    <h1>Audit Report</h1>
    <iaud-breadcrumb [breadcrumbList]="breadcrumbs"></iaud-breadcrumb>
    <mat-card class="add-audit">
      <mat-card-title>New Audit</mat-card-title>
      <iaud-audit-edit-form #editFormComponent
        [audit]="audit"
                            [isNew]="true"
                            (isValidChange)="toggleFormValidity($event)"
                            (isFinishLaterValidChange)="toggleFinishLaterFormValidity($event)"
      ></iaud-audit-edit-form>

      <div class="add-audit__buttons">
        <button mat-raised-button class="right-margin" routerLink="/audit">Cancel</button>
        <button mat-raised-button
                class="right-margin"
                (click)="submitAudit(true)"
                [disabled]="(isNextLoading$ | async) || (isLaterLoading$ | async)">
          <mat-spinner *ngIf="isLaterLoading$ | async" [diameter]="25"></mat-spinner>
          Save and finish later
        </button>
        <button mat-raised-button
                (click)="submitAudit()"
                [color]="'accent'"
                [disabled]="!isFormValid || (isNextLoading$ | async) || (isLaterLoading$ | async)">
          <mat-spinner *ngIf="isNextLoading$ | async" [diameter]="25"></mat-spinner>
          Next
        </button>
      </div>
    </mat-card>
  </div>
</section>
